import { render, staticRenderFns } from "./homeshoppingConsultation.vue?vue&type=template&id=57743102&scoped=true&"
import script from "./homeshoppingConsultation.vue?vue&type=script&lang=js&"
export * from "./homeshoppingConsultation.vue?vue&type=script&lang=js&"
import style0 from "./homeshoppingConsultation.vue?vue&type=style&index=0&id=57743102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57743102",
  null
  
)

export default component.exports